import React from 'react';

import { type UseQueryOptions, useQuery } from '@lumapps/base-api/react-query';

import { feedQueryKeys, getGroup, type GetGroupParams } from '../api';

export type GetGroupDTO = GetGroupParams & {
    /** Optional callback function to execute if the query fails. */
    onError?: () => void;
};

/**
 * Hook to get a group
 *
 * @param {GetGroupDTO} params
 * @param {UseGetConnectorOptions | undefined} options
 */
export const useGetGroup = ({ onError, ...getFeedParams }: GetGroupDTO, options?: UseQueryOptions) => {
    const query = useQuery({
        ...options,
        queryKey: feedQueryKeys.getGroup(getFeedParams),
        queryFn: async ({ signal }) => getGroup(getFeedParams, signal),
    });

    /**
     * If the call ends in an error, we want to execute the error callback.
     */
    React.useEffect(() => {
        if (query.isError && onError) {
            onError();
        }
    }, [onError, query.isError]);

    return query;
};
